// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3hDr3","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__cDAUL","gfeWrapper":"CalendarEvent_gfeWrapper__rFPI4"};